export default function NewsSection() {
  const newsItems = [
    {
      id: 1,
      image: 'https://tristatewarriors.com/wp-content/uploads/2024/03/test.png',
      title: 'WELCOME NEW GENERAL MANAGER RASHIDI HENDRIX',
      description: "We're thrilled to announce the arrival of our new General Manager, Rashidi Hendrix! With his wealth of experience and exceptional leadership, we're confident he'll steer the team to new heights of success. Welcome aboard, Rashidi!",
      link: '#',
    },
    {
      id: 2,
      image: 'https://tristatewarriors.com/wp-content/uploads/2024/04/news-back-isaiah.png',
      title: 'New Defensive Line Coach: Isiah Massey',
      description: "Join us in extending a warm welcome to Isiah Massey, our new Defensive Line Coach! With a proven track record of excellence and a passion for developing top-tier talent, Isiah brings a wealth of knowledge and energy to our team. We're excited to see the impact he'll make as we strive for greatness together on and off the field. Welcome, Isiah!",
      link: '#',
    },
    {
      id: 3,
      image: 'https://tristatewarriors.com/wp-content/uploads/2024/04/news-back-angelo-.png',
      title: 'Welcoming Angelo Mendez Our New Running Backs Coach',
      description: "Join us in extending a warm welcome to Angelo Mendez, our new Running Backs Coach! With a proven track record of excellence and a passion for developing top-tier talent, Angelo brings a wealth of knowledge and energy to our team. We're excited to see the impact he'll make as we strive for greatness together on and off the field. Welcome, Angelo!",
      link: '#',
    },
  ];

  return (
    <div id="news" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-bold mb-4">
            LATEST UPDATES
          </div>
          <h2 className="text-5xl font-black text-gray-900 mb-4">Team News</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Stay updated with the latest announcements, team changes, and exciting developments
          </p>
        </div>

        {/* News Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {newsItems.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4 line-clamp-3">
                  {item.description}
                </p>
                <a
                  href={item.link}
                  className="inline-flex items-center text-red-600 font-semibold text-sm hover:text-red-700 transition-colors cursor-pointer"
                >
                  Read More
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <a
            href="#all-news"
            className="inline-block bg-gray-900 text-white px-8 py-4 rounded-lg text-base font-bold hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer"
          >
            View All News
          </a>
        </div>
      </div>
    </div>
  );
}
